var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 32,
    viewBox: "0 0 166 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.753 16.0768C145.9 15.4999 144.969 15.1153 144.039 14.6153C143.457 14.3076 142.837 13.9999 142.333 13.5768C141.48 12.8845 141.635 11.4999 142.565 10.8845C143.845 10.0384 145.978 10.4999 146.21 12.2307C146.21 12.2691 146.249 12.3076 146.288 12.3076H148.226C148.265 12.3076 148.304 12.2691 148.304 12.2307C148.188 11.0384 147.722 10.0383 146.869 9.3845C146.055 8.76912 145.124 8.46143 144.116 8.46143C138.998 8.46143 138.533 13.846 141.286 15.5384C141.596 15.7307 144.31 17.0768 145.28 17.6922C146.249 18.2691 146.52 19.3461 146.133 20.1922C145.745 20.9614 144.776 21.4999 143.806 21.423C142.72 21.3461 141.906 20.7691 141.596 19.8845C141.557 19.7307 141.518 19.423 141.518 19.2691C141.518 19.2307 141.48 19.1922 141.441 19.1922H139.347C139.308 19.1922 139.27 19.2307 139.27 19.2691C139.27 20.7691 139.657 21.6153 140.665 22.3845C141.635 23.1153 142.682 23.423 143.806 23.423C146.675 23.423 148.149 21.8076 148.459 20.1537C148.692 18.5384 148.226 17.0768 146.753 16.0768Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3619 8.76904H54.4313H53.4232C53.3844 8.76904 53.3456 8.8075 53.3456 8.8075L51.6008 14.4614C51.562 14.5383 51.4844 14.5383 51.4457 14.4614L49.7008 8.8075C49.7008 8.76904 49.662 8.76904 49.6233 8.76904H48.6151H47.6845H46.4438C46.405 8.76904 46.3662 8.8075 46.3662 8.84596V23.2691C46.3662 23.3075 46.405 23.346 46.4438 23.346H48.5376C48.5764 23.346 48.6151 23.3075 48.6151 23.2691V12.3075C48.6151 12.2306 48.7315 12.1921 48.7702 12.269L50.5151 17.9614L50.6314 18.346C50.6314 18.3844 50.6702 18.3844 50.7089 18.3844H52.3375C52.3762 18.3844 52.415 18.346 52.415 18.346L52.5313 17.9614L54.2762 12.269C54.315 12.1921 54.4313 12.1921 54.4313 12.3075V23.2691C54.4313 23.3075 54.4701 23.346 54.5088 23.346H56.6027C56.6414 23.346 56.6802 23.3075 56.6802 23.2691V8.84596C56.6802 8.8075 56.6414 8.76904 56.6027 8.76904H55.3619Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 8.76904C114.493 8.76904 114.455 8.8075 114.455 8.8075L112.71 14.4614C112.671 14.5383 112.594 14.5383 112.555 14.4614L110.81 8.8075C110.81 8.76904 110.771 8.76904 110.732 8.76904H107.514C107.475 8.76904 107.437 8.8075 107.437 8.84596V23.2691C107.437 23.3075 107.475 23.346 107.514 23.346H109.608C109.647 23.346 109.685 23.3075 109.685 23.2691V12.3075C109.685 12.2306 109.802 12.1921 109.841 12.269L111.585 17.9614L111.702 18.346C111.702 18.3844 111.74 18.3844 111.779 18.3844H113.408C113.447 18.3844 113.485 18.346 113.485 18.346L113.602 17.9614L115.347 12.269C115.385 12.1921 115.502 12.1921 115.502 12.3075V23.2691C115.502 23.3075 115.54 23.346 115.579 23.346H117.673C117.712 23.346 117.751 23.3075 117.751 23.2691V8.84596C117.751 8.8075 117.712 8.76904 117.673 8.76904H114.532Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3902 8.76904H83.474H81.3802H77.4252C77.3864 8.76904 77.3477 8.8075 77.3477 8.84596V10.6537C77.3477 10.6921 77.3864 10.7306 77.4252 10.7306H81.2639V23.2691C81.2639 23.3075 81.3027 23.346 81.3414 23.346H83.4352C83.474 23.346 83.5128 23.3075 83.5128 23.2691V10.7306H87.3515C87.3902 10.7306 87.429 10.6921 87.429 10.6537V8.84596C87.4678 8.8075 87.429 8.76904 87.3902 8.76904Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7976 23.3461H101.698C101.736 23.3461 101.775 23.3077 101.775 23.2307L97.8201 8.76918C97.8201 8.73072 97.7813 8.73071 97.7426 8.73071H97.0058H95.7263H94.9896C94.9508 8.73071 94.912 8.76918 94.912 8.76918L90.957 23.2307C90.957 23.2692 90.9958 23.3461 91.0346 23.3461H92.9345C92.9733 23.3461 93.0121 23.3077 93.0121 23.3077L94.1753 19.0769C94.1753 19.0384 94.2141 19.0384 94.2529 19.0384H98.4793C98.518 19.0384 98.5568 19.0769 98.5568 19.0769L99.72 23.3077C99.72 23.3077 99.7588 23.3461 99.7976 23.3461ZM94.7569 16.9615L96.3079 11.3076C96.3467 11.2307 96.4242 11.2307 96.463 11.3076L98.014 16.9615C98.014 17 97.9752 17.0769 97.9364 17.0769H94.8732C94.7957 17.0769 94.7569 17 94.7569 16.9615Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.446 23.3461H134.346C134.385 23.3461 134.424 23.3077 134.424 23.2307L130.469 8.76918C130.469 8.73072 130.43 8.73071 130.391 8.73071H129.654H128.375H127.638C127.599 8.73071 127.56 8.76918 127.56 8.76918L123.605 23.2307C123.605 23.2692 123.644 23.3461 123.683 23.3461H125.583C125.622 23.3461 125.661 23.3077 125.661 23.3077L126.824 19.0769C126.824 19.0384 126.863 19.0384 126.901 19.0384H131.128C131.166 19.0384 131.205 19.0769 131.205 19.0769L132.368 23.3077C132.368 23.3077 132.407 23.3461 132.446 23.3461ZM127.405 16.9615L128.956 11.3076C128.995 11.2307 129.073 11.2307 129.111 11.3076L130.662 16.9615C130.662 17 130.624 17.0769 130.585 17.0769H127.522C127.444 17.0769 127.405 17 127.405 16.9615Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2099 21.1921V16.7306C65.2099 16.6921 65.2486 16.6537 65.2874 16.6537H70.9097C70.9485 16.6537 70.9872 16.6152 70.9872 16.5767V14.769C70.9872 14.7306 70.9485 14.6921 70.9097 14.6921H65.2874C65.2486 14.6921 65.2099 14.6537 65.2099 14.6152V10.8075C65.2099 10.769 65.2486 10.7306 65.2874 10.7306H71.6464C71.6852 10.7306 71.724 10.6921 71.724 10.6537V8.84596C71.724 8.8075 71.6852 8.76904 71.6464 8.76904H65.2099H63.0385C62.9997 8.76904 62.9609 8.8075 62.9609 8.84596V10.7306V14.7306V16.6921V21.3075V23.2691C62.9609 23.3075 62.9997 23.346 63.0385 23.346H65.2099H71.9178C71.9566 23.346 71.9954 23.3075 71.9954 23.2691V21.3844C71.9954 21.346 71.9566 21.3075 71.9178 21.3075H65.2486C65.2486 21.2691 65.2099 21.2306 65.2099 21.1921Z",
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.985 23.1923L158.695 15.7307C158.657 15.6923 158.657 15.6538 158.695 15.6153L165.248 8.8461C165.287 8.80764 165.248 8.73071 165.21 8.73071H162.534C162.495 8.73071 162.495 8.73072 162.495 8.76918L156.912 14.5384C156.873 14.5769 156.796 14.5384 156.796 14.5V8.88456C156.796 8.8461 156.757 8.80763 156.718 8.80763H154.585C154.547 8.80763 154.508 8.8461 154.508 8.88456V23.3077C154.508 23.3461 154.547 23.3846 154.585 23.3846H156.679C156.718 23.3846 156.757 23.3461 156.757 23.3077V16.9615C156.757 16.8846 156.834 16.8461 156.873 16.923L163.155 23.3846L163.193 23.423H165.869C165.985 23.3461 166.024 23.2307 165.985 23.1923Z",
    fill: "#161616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9807 1L19.2627 10.3846L21.6279 4.84616L31.9807 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58984 1L15.2303 10.4616L12.9814 4.84616L2.58984 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4053 22.7307L23.9932 27.8846L31.2828 29.8846L33.3378 22.8461L27.4053 22.7307Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 22.8461L3.32653 29.8846L10.5773 27.8846L7.20397 22.7307L1.27148 22.8461Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1891 14.0385L8.17285 17.077L15.3461 17.3847L15.1135 9.69238L10.1891 14.0385Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4207 14.0383L19.4188 9.61523L19.2637 17.3845L26.4369 17.0768L24.4207 14.0383Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5781 27.8848L14.9209 25.8078L11.1597 22.8848L10.5781 27.8848Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 25.8078L23.9934 27.8848L23.4118 22.8848L19.6895 25.8078Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9934 27.8845L19.6895 25.8076L20.0384 28.5769L19.9996 29.7692L23.9934 27.8845Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5771 27.8845L14.6097 29.7692L14.5709 28.5769L14.9199 25.8076L10.5771 27.8845Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.688 21.0385L11.082 20L13.6024 18.8462L14.688 21.0385Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 21.0385L20.9688 18.8462L23.5279 20L19.9219 21.0385Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5785 27.8846L11.1988 22.7307L7.20508 22.8461L10.5785 27.8846Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4131 22.7307L23.9947 27.8846L27.4069 22.8461L23.4131 22.7307Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4369 17.0769L19.2637 17.3846L19.9228 21.0384L20.9697 18.8461L23.5289 20L26.4369 17.0769Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0829 20L13.6032 18.8461L14.6889 21.0384L15.3481 17.3846L8.1748 17.0769L11.0829 20Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17285 17.0769L11.1585 22.8846L11.0809 20L8.17285 17.0769Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5275 20L23.4111 22.8846L26.4355 17.0769L23.5275 20Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3467 17.3845L14.6875 21.0384L15.5018 25.3845L15.6956 19.6538L15.3467 17.3845Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2621 17.3845L18.9131 19.6538L19.0682 25.3845L19.9212 21.0384L19.2621 17.3845Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9214 21.0385L19.0684 25.3846L19.6887 25.8077L23.4111 22.8846L23.5274 20L19.9214 21.0385Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.082 20L11.1596 22.8846L14.9207 25.8077L15.5023 25.3846L14.688 21.0385L11.082 20Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 29.7694L20.0381 28.5771L19.6891 28.3078H14.8811L14.5709 28.5771L14.6097 29.7694L10.5771 27.8848L11.973 29.0386L14.8423 31.0002H19.7279L22.5972 29.0386L23.9931 27.8848L19.9993 29.7694Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 25.8078L19.0691 25.3848H15.5019L14.9203 25.8078L14.5713 28.5771L14.8815 28.3078H19.6895L20.0385 28.5771L19.6895 25.8078Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5238 11L33.6095 5.8077L31.9809 1L19.6895 10.0769L24.4199 14.0385L31.0891 15.9616L32.5626 14.2692L31.9422 13.8077L32.9503 12.8846L32.1748 12.2692L33.1829 11.5L32.5238 11Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.8077L2.08568 11L1.38774 11.5L2.39588 12.2692L1.62039 12.8846L2.6673 13.8077L2.00813 14.2692L3.48156 15.9616L10.1895 14.0385L14.92 10.0769L2.58975 1L1 5.8077Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0894 15.9614L24.4202 14.0383L26.4365 17.0768L23.4121 22.8845L27.4059 22.846H33.3384L31.0894 15.9614Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1896 14.0383L3.48163 15.9614L1.27148 22.846H7.20397L11.159 22.8845L8.17333 17.0768L10.1896 14.0383Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2629 17.3847L19.6894 10.077L21.6281 4.84619H12.9814L14.9202 10.077L15.3467 17.3847L15.5018 19.6924V25.3847H19.069V19.6924L19.2629 17.3847Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.7fe0cc30fa0cc1b01ea236bd1e0e1d02.svg";
export { ForwardRef as ReactComponent };